module.exports = __webpack_public_path__ + "bba6156be64be5b56c6a2c6dfc66429e.jpg";